import { render, staticRenderFns } from "./AdTypeCell.vue?vue&type=template&id=661f56e1"
import script from "./AdTypeCell.vue?vue&type=script&lang=js"
export * from "./AdTypeCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports